import { Theme } from "@material-ui/core/styles";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => ({
  bottomButton: {
    marginTop: theme.spacing(1),
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  sportTablesWrapper: {
    "& .sport-table": {
      margin: "0rem -1rem",
      padding: "1.5rem 1rem",
    },
    "& .sport-table:nth-child(odd)": {
      backgroundColor: `rgba(${hexToRGB(theme.palette.primary.main)}, 0.066)`,
    },
    "& .sport-table:only-child": {
      backgroundColor: theme.palette.background.paper,
    },
  },
  surveyComplete: {
    color: "green",
  },
  surveyLink: {
    fontSize: 12,
  },

  tableHeader: {
    marginTop: "2em",
  },
});



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/styles.ts